import { Heading } from "@/components/ui/Heading";
import { Checkbox } from "@/components/ui/Checkbox";
import classes from "./ThankYouPage.module.scss";
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import type { ThankYouPageFormProps } from "./ThankYouPageProps";
import { useTranslation } from "@/hooks/useTranslation";
import { trackError } from "@/utils/error-monitoring";
import { Card } from "@/components/ui/Card";
import { getAsset } from "@/utils/assets";

export function ThankYouPageForm(props: ThankYouPageFormProps) {
  const {
    title,
    "body-html": bodyHtml,
    "checkbox-label": checkboxLabel,
    "success-message": successMessage,
    translationsParams,
    sendSubmission,
  } = props;

  const t = useTranslation("thank_you_page");

  const [checked, setChecked] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(ev.target.checked);
  };

  const handleSumit = async () => {
    setProcessing(true);
    try {
      await sendSubmission();
      setShowSuccess(true);
    } catch (error) {
      trackError(error as Error);
      setError("An error occurred");
    } finally {
      setProcessing(false);
    }
  };

  if (error) {
    return (
      <Card className={classes.card}>
        <div className={classes.formHeader}>
          <Heading as="h3" size="xl" gutterBottom>
            {t(title.i18n, translationsParams)}
          </Heading>

          <div className={classes.errorMessage}>{error}</div>
        </div>
      </Card>
    );
  }

  if (showSuccess) {
    return (
      <Card
        className={classes.card}
        bgImage={getAsset("images/bg-success.png")}
      >
        <div className={classes.formHeader}>
          <Heading as="h3" size="xl" gutterBottom>
            {t(title.i18n, translationsParams)}
          </Heading>
          <div className={classes.formatter}>
            {t(successMessage.i18n, translationsParams)}
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card className={classes.card}>
      <div className={classes.formHeader}>
        <Heading as="h3" size="xl" gutterBottom>
          {t(title.i18n, translationsParams)}
        </Heading>
        <div className={classes.formatter}>
          {t(bodyHtml.i18n, translationsParams)}
        </div>
      </div>

      <div>
        <Checkbox checked={checked} onChange={handleChange}>
          {t(checkboxLabel.i18n, translationsParams)}
        </Checkbox>
      </div>

      <div className={classes.formFooter}>
        {checked && (
          <Button
            disabled={processing}
            variant="outlined"
            onClick={handleSumit}
          >
            {t("confirm")}
          </Button>
        )}
      </div>
    </Card>
  );
}
